
import SpeedKitMessage from "~/components/SpeedKitMessage.vue";

export default {
  components: {
    SpeedKitMessage
  },
}
